import React, { Component } from "react";
import Api from "../../../../Services/Api";
import API from "../../../../Services/Api";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import * as R from 'ramda';
import { Redirect } from 'react-router-dom'

import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import { checkResponseError } from "../../../../Services/Utils";
import SimpleSearch from "../../../../modules/SimpleSearch";
import EmployeeSearchForm from "../../../masterData/master-series/varian/searchEmployee";
import DDLParamValue from "../../../../modules/commons/DDLParamValue";
import FormEditRole from "../../../masterData/master-series/role/formEditRole";
import NormalInput from "../../../../modules/NormalInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";


const CryptoJS = require("crypto-js");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class formPDI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data
        ? props.data
        : {
            grDocsNo: null,
            noSL: null,
            tanggalSL: null,
            kodeSL: null,

            userId: null,
            phoneNumber: null,
            
            status: "Active",
            status2: "Yes",
            emplId: null,
            name: "",
            action: "NEW",
            dealerCode: null,
            
            
            
            kodePos: null,
            deskripsi: null,
            locator: null,
            dealerName: null,
            bankLogo: null,        
          },
      name: "",
      detailVisible: false,
      disableName: false,
      category: null,
      employeeSearchFormVisible: false,
      createVisible: false,
      loadSave: false,
      savePopUpVisible: false,
      deletePopUpVisible: false,
      companyData: [],
      dataRole: [],
      dataTable: [
      ["1", "UTP 1", "Black", "123abc1", "456def1", "Active"],
      ["2", "UTP 2", "Black", "123abc2", "456def2", "Active"],
      ["3", "UTP 3", "Red", "123abc3", "456def3", "Active"], 
      ["4", "UTP 4", "Black", "123abc4", "456def4", "Active"],
      ["5", "UTP 5", "red", "123abc5", "456def5", "Active"],
      ["6", "UTP 6", "Black", "123abc6", "456def6", "Active"],
      ["7", "UTP 7", "Black", "123abc7", "456def7", "Active"],
      ["8", "UTP 8", "Black", "123abc8", "456def8", "Active"],
      ["9", "UTP 9", "Green", "123abc9", "456def9", "Active"],
      ["10", "UTP 10", "Black", "123abc10", "456def10", "Active"],
      ["11", "UTP 11", "Black", "123abc11", "456def11", "Active"],
      ["12", "UTP 12", "Black", "123abc12", "456def12", "Active"],
      ["13", "UTP 13", "Black", "123abc13", "456def13", "Active"],
      ["14", "UTP 14", "Black", "123abc14", "456def14", "Active"],
      ["15", "UTP 15", "Black", "123abc15", "456def15", "Active"],
      ["16", "UTP 16", "Black", "123abc16", "456def16", "Active"],
      ["17", "UTP 17", "Black", "123abc17", "456def17", "Active"],
      ["18", "UTP 18", "Black", "123abc18", "456def18", "Active"],
      ["19", "UTP 19", "Yellow", "123abc19", "456def19", "Active"],
      ["20", "UTP 20", "Black", "123abc20", "456def20", "Active"]
      ],
      countDataRole: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",

      confirmPassVisible: false,
      PassVisible: false,

      locator:[
        { "label": "Jawa Barat"},
        { "label": "Jawa Tengah"},
        { "label": "Jawa Timur"},
        { "label": "Kalimantan Barat"},
        { "label": "Kalimantan Selatan"},
        { "label": "Kalimantan Tengah"},
        { "label": "Kalimantan Timur"},
        { "label": "DKI Jakarta"},
      ]
    };
  }

  showPassword = (type) => {
    switch (type) {
      case "pass":
        this.setState({ PassVisible: !this.state.PassVisible });
        break;
      case "confirm":
        this.setState({ confirmPassVisible: !this.state.confirmPassVisible });
        break;
      default:
        break;
    }
  };

  componentDidMount() {
    this.getCompanyDdl();
    if (this.props.type !== "create") {
      this.setDataValue(this.state.data);
      this.getRole(this.state.table_page, this.state.table_limit);
      // console.log(JSON.stringify(this.state.data, null, 2))
    }
  }

  setDataValue(data) {
    let dataCompany = {
      value: data.companyId,
      label: data.companyName,
    };

    let dataUserCategory = {
      value: data.categoryId,
      label: data.category,
    };

    this.setState({
      data: {
        ...this.state.data,
        categoryIdSelect: dataUserCategory,
      },
      companyIdSelect: dataCompany,
      name: data.name,
      category: data.category,
      disableName: data.category === "Non Employee & Outsource" ? false : true,
    });
  }

  getCompanyDdl() {
    let payload = {
      companyGroupId: "TAB",
    };
    Api.create("MASTERDATA_EKSAD")
      .postGetCompanyDdl(payload)
      .then((res) => {
        if (res.ok && res.data.status === "S") {
          let array = [];
          res.data.data &&
            res.data.data.map((item) => {
              array.push({
                value: item.companyId,
                label: item.companyName,
              });
            });
          this.setState({
            companyData: array,
          });
        }
      });
  }

  getRole = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      roleName: this.state.table_query,
      userId: this.state.data.userId,
    };
    let res = await API.create("MASTERDATA_EKSAD").postGetUserRole(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        let dataTable =
          res.data.data &&
          res.data.data.listRole.map((value) => {
            const { roleCode, roleName, accessType } = value;
            return [roleCode, roleName, accessType];
          });
        this.setState({
          dataRole: res.data.data && res.data.data.listRole,
          dataTable,
          countDataRole: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  validation(data) {
    if (!this.state.data.grDocsNo) {
      return alert("grDocsNo is mandatory.");
    }
    if (!this.state.data.noSL) {
      return alert("No Shiping Number is mandatory.");
    }
    if (!this.state.data.tanggalSL) {
      return alert("Tanggal SL is mandatory.");
    }
    if (!this.state.data.kodeSL) {
        return alert("kodeSL is mandatory.");
    }
    if (!this.state.data.kodePos) {
        return alert("Kode pos is mandatory.");
    }
    if (this.state.data.locator === 3 && this.state.name === "") {
      return alert("locator is mandatory.");
    }
    if (this.state.data.dealerCode === 3 && this.state.name === "") {
        return alert("Kode Dealer is mandatory.");
    }
    if (this.state.data.bankLogo === 3 && this.state.name === "") {
        return alert("Kode Dealer is mandatory.");
    }
    if (this.state.data.dealerName === 3 && this.state.name === "") {
        return alert("Nama Dealer is mandatory.");
    }  
    if (this.state.data.deskripsi === 3 && this.state.name === "") {
        return alert("deskripsi is mandatory.");
    }
    if (this.state.data.phoneNumber === 3 && this.state.name === "") {
        return alert("Phone Number is mandatory.");
    }
    

    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (this.state.data.kodeSL && !pattern.test(this.state.data.kodeSL)) {
      return alert("kodeSL is not valid");
    }

    if (this.props.type !== "create") {
      this.isLoad(true);
      this.setState(
        {
          data: {
            ...this.state.data,
            action: "EDIT",
          },
        },
        () => {
          this.onClickSave();
        }
      );
    } else {
      this.onClickSave();
    }
  }

  onClickSave = () => {
    this.state.data.password = CryptoJS.MD5(
      this.state.data.password
    ).toString();

    Api.create("MASTERDATA_EKSAD")
      .postSaveUser(this.state.data)
      .then((res) => {
        if (res.ok && res.data.status === "S") {
          this.isLoad(false);
          this.props.onClickClose();
          this.props.onClickSave(res);
        } else {
          this.isLoad(false);
          this.props.onClickSave(res);
        }
      });
  };

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  onChangeCombo = (event, name) => {
    let value = event.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;

    switch (menu) {
      case "slide-menu-view":
        this.setState({
          detailVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  columnsUser = [
    { name: "#" },
    { name: "Unit Type" },
    { name: "Warna" },
    { name: "NoKa" },
    { name: "NoSin" },
    { name: "Status" },
    


    {
        name: "All loc",
        options: {
            customBodyRender: (val, tableMeta) => {
                return (
                  <SimpleDDL
                  box={"search"}
                  
                  
                  name={"locator"}
                  options={this.state.locator}
                  onChange={(e) => this.onChangeCombo(e, "locator")}
                //   disabled={this.props.type === "view" || this.props.type === "edit"}
                  value={this.state.data.provinsi}
                />
                        
                    
                );
            }
        }
    }
];

getCountPage = async (page, limit) => {
  let payload = {
      limit: limit, 
      offset: page,

  } 
}
  openDetailForm = () => {
    this.setState({ detailVisible: !this.state.detailVisible });
  };

  openSearchEmployee = () => {
    if (
      this.props.type === "create" &&
      this.state.data.categoryId &&
      this.state.disableName
    ) {
      this.setState({
        employeeSearchFormVisible: !this.state.employeeSearchFormVisible,
      });
    }
  };

  handleChooseEmployee = async (response) => {
    console.log("Ini Data Employee : " + JSON.stringify(response, null, 2));
    this.setState({
      data: {
        ...this.state.data,
        name: response.emplName,
        emplId: response.emplId,
      },
      name: response.emplName,
    });
  };

  render() {
        let { toCount, table_query } = this.state
        let tableOptions = {
            ...options,
            serverSide: true, serverSide:false,
            count: toCount,
            searchText: table_query,
            rowsPerPage: this.state.table_limit,
            page: this.state.table_page,
            onColumnSortChange: (changedColumn, direction) => {
                let order = 'desc';
                if (direction === 'ascending') {
                    order = 'asc';
                }

                let columnOrder = "";

                if (changedColumn === "number") {
                    columnOrder = "number";
                }

                if (changedColumn === "unitType") {
                    columnOrder = "unitType";
                }

                if (changedColumn === "warna") {
                    columnOrder = "warna";
                }

                if (changedColumn === "noKa") {
                    columnOrder = "noKa";
                }

                if (changedColumn === "noSin") {
                    columnOrder = "noSin";
                }

                if (changedColumn === "Status") {
                    columnOrder = "status";
                }
                if (changedColumn === "locator") {
                  columnOrder = "locator";
              }

                this.columnsUser.map((value, index) => {
                    if (changedColumn === value.name && value.name !== "Action") {
                        value.options = { sortDirection: order }
                    } else {
                        value.options = { ...value.options, sortDirection: "none" }
                    }
                })

                this.setState({
                    dataDto: {
                        ...this.state.dataDto,
                        sortBy: columnOrder,
                        orderBy: order
                    }
                }, () => {
                    this.getCountPage(this.state.table_page, this.state.table_limit);
                });
            },
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        this.setState({ table_page: tableState.page })
                        this.getCountPage(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'changeRowsPerPage':
                        this.setState({ table_limit: tableState.rowsPerPage })
                        this.getCountPage(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'search':
                        let searchText = tableState.searchText ? tableState.searchText : ""
                        this.setState({ table_query: searchText }, () => {
                            this.handleSearch();
                        })
                        break;
                    default:
                        break;
                }
            }
        }
    return (
      <div>
        <div className="app-popup app-popup-show">
          <div className="padding-top-20px" />
          <div
            className="popup-content background-white border-radius"
            style={{ width: "70%" }}
          >
            <div className="popup-panel grid grid-2x">
              <div className="col-1">
                <div className="popup-title">{"Good Receive Locator"}</div>              
              </div>
              <div className="col-2 content-right">
                <button
                  className="btn btn-circle btn-grey"
                  onClick={this.props.onClickClose}
                >
                  <i className="fa fa-lg fa-times" />
                </button>
              </div>
            </div>
            <form
              action="#"
              onSubmit={(e) => {
                e.preventDefault();
                this.validation(this.state.data);
              }}
            >
              <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
              <div className="popup-title">{"Type: C2D/M2D/MD/#rd Party"}</div>
                <div className="column-1">{this.renderForm()}</div>
                <div className="column-2">{this.renderForm2()}
                  {/* <div className="margin-5px">*/}
                  {/*    <div className="txt-site txt-11 txt-main txt-bold">*/}
                  {/*        <h4><span style={{color: 'red'}}>*format file (excel)</span></h4>*/}
                  {/*    </div>*/}
                  {/*</div> */}
                </div>
                <div>
                <SimpleTextArea
                    name="deskripsi"
                    row = {6}
                    label={"deskripsi"}
                    mandatory={this.props.type !== "view"}
                  //   readOnly={this.props.type !== "create"}
                    value={this.state.data.deskripsi}
                    onChange={this.onchangeInput}
              />
              </div>
              <div>
              
              </div>
                
              </div>
              
                
                
              {this.props.type === "create" ? (
                <div className="padding-left-15px padding-right-15px grid grid-1x grid-mobile-none">
                  <div className="column-1">
                    <div className="txt-site txt-11 txt-main txt-bold">
                      
                    </div>
                  </div>
                </div>
              ) : null}

                  <div>
               <MuiThemeProvider theme={getMuiTheme()}>
                   <MUIDataTable
                       key={toCount}
                       title={'Receiving Unit'}
                       subtitle={"Setting data of Receiving Unit"}
                       data={this.state.dataTable}
                       columns={this.columnsUser}
                       options={tableOptions}
                      //  buttonCreate={this.state.buttonAccess.btnAdd}
                      //  onCreate={this.openCreateForm.bind(this)}
                   />
               </MuiThemeProvider>
                            </div>

              {/* kontaier buat status dan intergration jadi row */}
              {/* <div>
                <div className="padding-left-15px padding-right-15px padding-top-15px grid grid-1x grid-mobile-none gap-15px">
                  <div className="column-1">
                    <div className="margin-bottom-20px">
                      <div className="margin-5px">
                        <div className="txt-site txt-11 txt-main txt-bold">
                          <h4>Integration</h4>
                        </div>
                      </div>
                      <div className="margin-bottom-10px">
                        <div className="margin-10px">
                          <label className="radio">
                            <input
                              type="checkbox"
                              disabled={this.props.type === "view"}
                              checked={this.state.data.status2 === "Yes"}
                              onChange={(e) => {
                                this.setState({
                                  data: {
                                    ...this.state.data,
                                    status2: e.target.checked ? "Yes" : "No",
                                  },
                                });
                              }}
                            />
                            <span className="checkmark" />
                            <div className="txt-site txt-11 txt-bold txt-main">
                              <h4>{this.state.data.status2}</h4>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="padding-left-15px padding-right-15px padding-top-15px grid grid-1x grid-mobile-none gap-15px">
                  <div className="col-2">
                    <div className="margin-bottom-20px">
                      <div className="margin-5px">
                        <div className="txt-site txt-11 txt-main txt-bold">
                          <h4>Status</h4>
                        </div>
                      </div>
                      <div className="margin-bottom-10px">
                        <div className="margin-10px">
                          <label className="radio">
                            <input
                              type="checkbox"
                              disabled={this.props.type === "view"}
                              checked={this.state.data.status === "Active"}
                              onChange={(e) => {
                                this.setState({
                                  data: {
                                    ...this.state.data,
                                    status: e.target.checked
                                      ? "Active"
                                      : "Inactive",
                                  },
                                });
                              }}
                            />
                            <span className="checkmark" />
                            <div className="txt-site txt-11 txt-bold txt-main">
                              <h4>{this.state.data.status}</h4>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              {this.props.type !== "create" ? (
                <div className="padding-15px grid grid-1x grid-mobile-none gap-15px">
                  <div className="column-1">
                    <SimpleInput
                      required
                      label={"Position"}
                      name="position"
                      readOnly={true}
                      value={this.state.data.position}
                      onChange={this.onchangeInput}
                    />
                  </div>
                </div>
              ) : null}
              {this.props.type !== "create" ? (
                <div className="padding-15px grid grid-1x grid-mobile-none gap-15px">
                  <div className="column-1">{this.renderTable()}</div>
                </div>
              ) : null}
              {this.props.type !== "create" ? (
                <div className="margin-15px">
                  <label className="radio">
                    <input
                      type="checkbox"
                      disabled={this.props.type === "view"}
                      checked={this.state.isChangePassword}
                      onChange={(e) => {
                        this.setState({
                          isChangePassword: e.target.checked,
                        });
                      }}
                    />
                    <span className="checkmark" />
                    <div className="txt-site txt-11 txt-bold txt-main">
                      <h4>Change Password</h4>
                    </div>
                  </label>
                </div>
              ) : null}
             

              {this.state.isChangePassword && (
                <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
                  <div className="column-1">
                    {this.props.type !== "view" ? (
                      <div className="card-date-picker">
                        <div className="margin-5px">
                          <div className="txt-site txt-11 txt-main txt-bold">
                            <h4>
                              Password <span style={{ color: "red" }}>*</span>
                            </h4>
                          </div>
                        </div>
                        <div className="double margin-bottom-20px">
                          <input
                            type={this.state.PassVisible ? "text" : "password"}
                            className="input padding-15px"
                            required
                            onChange={(e) =>
                              this.setState({
                                data: {
                                  ...this.state.data,
                                  password: e.target.value,
                                },
                              })
                            }
                            value={this.state.data.password}
                          />
                          <button
                            type="button"
                            className="btn btn-grey border-left btn-no-radius"
                            onClick={this.showPassword.bind(this, "pass")}
                          >
                            <i
                              className={
                                this.state.PassVisible
                                  ? "fa fa-lg fa-eye"
                                  : "fa fa-lg fa-eye-slash"
                              }
                            />
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="column-2">
                    {this.props.type !== "view" ? (
                      <div className="card-date-picker">
                        <div className="margin-5px">
                          <div className="txt-site txt-11 txt-main txt-bold">
                            <h4>
                              Confirm Password{" "}
                              <span style={{ color: "red" }}>*</span>
                            </h4>
                          </div>
                        </div>
                        <div className="double margin-bottom-20px">
                          <input
                            type={
                              this.state.confirmPassVisible
                                ? "text"
                                : "password"
                            }
                            className="input padding-15px"
                            required
                            onChange={(e) =>
                              this.setState({
                                data: {
                                  ...this.state.data,
                                  confirmPassword: e.target.value,
                                },
                              })
                            }
                            value={this.state.data.confirmPassword}
                          />
                          <button
                            type="button"
                            className="btn btn-grey border-left btn-no-radius"
                            onClick={this.showPassword.bind(this, "confirm")}
                          >
                            <i
                              className={
                                this.state.confirmPassVisible
                                  ? "fa fa-lg fa-eye"
                                  : "fa fa-lg fa-eye-slash"
                              }
                            />
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
              {this.state.isChangePassword && (
                <div className="padding-15px grid grid-1x grid-mobile-none gap-15px">
                  <div className="column-1">
                    <div className="txt-site txt-11 txt-main txt-bold">
                      <h4>
                        For a strong password, please use a hard to guess
                        combination of text with upper and lower case character,
                        symbols and numbers
                      </h4>
                    </div>
                  </div>
                </div>
              )}
              <div className="padding-15px">
                <div className="grid grid-2x">
                  <div className="col-1" />
                  <div className="col-2 content-right">
                    {this.props.type === "edit" ||
                    this.props.type === "create" ? (
                      <button
                        className="btn btn-red"
                        type="submit"
                        disabled={this.state.loadSave}
                      >
                        <span>
                          {!this.state.loadSave ? "Recieve" : "Saving..."}
                        </span>
                      </button>
                    ) : null}

                    <button
                      style={{ marginLeft: "15px" }}
                      className="btn btn-back"
                      type="button"
                      onClick={this.props.onClickClose.bind(this)}
                    >
                      <span>BACK</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div>
              {this.state.employeeSearchFormVisible && (
                <EmployeeSearchForm
                  data={this.state.category}
                  stateData={this.state.data}
                  onClickClose={this.openSearchEmployee.bind(this)}
                  onChoose={this.handleChooseEmployee.bind(this)}
                  mandatory
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  columnRole = [
    "Role Code",
    "Role Name",
    {
      name: "Access Type",
      options: {
        customBodyRender: (val) => {
          return (
            <div
              style={{
                width: "90px",
                backgroundColor: val === "Allowed" ? "#00B9F2" : "red",
                borderRadius: 5,
                justifyContent: "center",
              }}
            >
              <div style={{ marginLeft: "20px", color: "white" }}>{val}</div>
            </div>
          );
        },
      },
    },
    this.props.type !== "view"
      ? {
          name: "Action",
          options: {
            customBodyRender: (val, tableMeta) => {
              return (
                <div style={{ width: "115px" }}>
                  <button
                    className="btnAct"
                    style={{ marginRight: 15, backgroundColor: "transparent" }}
                    onClick={this.opSidePage(
                      "slide-menu-view",
                      tableMeta.rowIndex
                    )}
                  >
                    <i
                      className="fa fa-lw fa-ellipsis-v"
                      style={{
                        backgroundColor: "transparent",
                        color: "#004c97",
                        fontSize: 20,
                      }}
                    />
                  </button>
                </div>
              );
            },
          },
        } : "",
  ];

  renderTable() {
    let { countDataRole, table_query } = this.state;
    let tableOptions = {
      ...options,
      serverSide: true,
      count: countDataRole,
      searchText: table_query,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getRole(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getRole(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.getRole(tableState.page, tableState.rowsPerPage);
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div>
        
        {this.state.detailVisible && (
          <FormEditRole
            type={"view"}
            data={this.state.dataRole[this.state.selectedIndex]}
            formUser={true}
            loadSave={this.state.loadSave}
            onClickClose={this.openDetailForm.bind(this)}
          />
        )}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <SimpleInput
          name="grDocsNo"
          label={"GR Docs No"}
          mandatory={this.props.type !== "view"}
        //   readOnly={this.props.type !== "create"}
          value={this.state.data.grDocsNo}
          onChange={this.onchangeInput}
        />
        <SimpleInput
          name="noSL"
          label={"No SL"}
          mandatory={this.props.type !== "view"}
        //   readOnly={this.props.type !== "create"}
          value={this.state.data.noSL}
          onChange={this.onchangeInput}
        />
        <SimpleInput
          name="tanggalSL"
          label={"Tanggal SL"}
          mandatory={this.props.type !== "view"}
        //   readOnly={this.props.type !== "create"}
          value={this.state.data.tanggalSL}
          onChange={this.onchangeInput}
        />
        
        {/* <SimpleInput
          name="dealerCode"
          label={"Dealer Code"}
          value={this.state.data.dealerCode}
          onChange={this.onchangeInput}
        //   readOnly={this.props.type === "view" || this.state.disableName}
          mandatory
        />
        <SimpleInput
          name="bankLogo"
          label={"Bank Logo (hrusnya img)"}
          value={this.state.data.bankLogo}
          onChange={this.onchangeInput}
        //   readOnly={this.props.type === "view" || this.state.disableName}
          mandatory
        /> */}
        {/* {this.props.type === "create" &&
                        <div className="card-date-picker">
                            <div className="margin-5px">
                            <div className="txt-site txt-11 txt-main txt-bold">
                                <h4>
                                    Password <span style={{ color: "red" }}>*</span>
                                </h4>
                            </div>
                            </div>
                            <div className="double margin-bottom-20px">
                        <input
                            type={this.state.PassVisible ? "text" : "password"}
                            className="input padding-15px"
                            required
                            onChange={(e) => this.setState({
                                data:{
                                    ...this.state.data,
                                    password:e.target.value
                                }
                            })}
                            value={this.state.data.password}                                            />
                        <button
                            type="button"
                            className="btn btn-grey border-left btn-no-radius"
                            onClick={this.showPassword.bind(this, "pass")}
                        >
                            <i className={this.state.PassVisible ? "fa fa-lg fa-eye": "fa fa-lg fa-eye-slash"}/>
                        </button>
                        </div>
                        </div>
                } */}
      </div>
    );
  }

  renderForm2() {
    return (
      <div>
        
        <NormalInput
          name="kodeSL"
          label={"kodeSL"}
          mandatory={this.props.type !== "view"}
        //   readOnly={this.props.type !== "create"}
          value={this.state.data.kodeSL}
          onChange={this.onchangeInput}
        />
        {/* {/* <SimpleInput
          name="kodePos"
          label={"Kode Pos"}
          mandatory={this.props.type !== "view"}
        //   readOnly={this.props.type !== "create"}
          value={this.state.data.kodePos}
          onChange={this.onchangeInput}
        />
        <NormalInput
          name="phoneNumber"
          label={"Phone Number"}
          mandatory={"true"}
          value={this.state.data.phoneNumber}
          onChange={this.onchangeInput}
        //   readOnly={this.props.type === "view" || this.state.disableName}
        />

        <SimpleInput
          name="dealerName"
          label={"Dealer Name"}
          value={this.state.data.dealerName}
          onChange={this.onchangeInput} 
        //   readOnly={this.props.type === "view" || this.state.disableName}
        /> */}

        {/* {this.props.type === "create" &&
                <div className="card-date-picker">
                    <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        <h4>
                            Confirm Password <span style={{ color: "red" }}>*</span>
                        </h4>
                    </div>
                    </div>
                    <div className="double margin-bottom-20px">
                <input
                    type={this.state.confirmPassVisible ? "text" : "password"}
                    className="input padding-15px"
                    required
                    onChange={(e) => this.setState({
                        data:{
                            ...this.state.data,
                            confirmPassword:e.target.value
                        }
                    })}
                    value={this.state.data.confirmPassword}                                            />
                <button
                    type="button"
                    className="btn btn-grey border-left btn-no-radius"
                    onClick={this.showPassword.bind(this, "confirm")}
                >
                    <i className={this.state.confirmPassVisible ? "fa fa-lg fa-eye": "fa fa-lg fa-eye-slash"}/>
                </button>
                </div>
                </div>
                } */}
      </div>
    );
  }
}

export default formPDI;
